import { GlobalLogoMark } from "./GlobalLogo";

export interface GlobalLoaderProps {
  size?: "sm" | "md" | "lg";
  text?: string;
  inline?: boolean;
  className?: string;
}

const sizeMap = {
  sm: 32,
  md: 48,
  lg: 64,
};

export default function GlobalLoader({
  size = "md",
  text,
  inline = false,
  className = "",
}: GlobalLoaderProps) {
  const s = sizeMap[size];

  const content = (
    <>
      <div className="relative">
        <GlobalLogoMark size={s} className="animate-rfw-logo" />
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <svg width={s} height={s * 0.47} viewBox="0 0 120 56" className="animate-rfw-wave-accent">
            <path
              d="M34 30 Q38 22 42 30 Q46 38 50 30 Q54 22 58 30"
              fill="none"
              stroke="#06B6D4"
              strokeWidth={2.5}
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ opacity: 0.8 }}
            />
          </svg>
        </div>
      </div>
      {text && (
        <span className="text-xs text-foreground-500/60 tracking-wider font-medium animate-pulse">
          {text}
        </span>
      )}
    </>
  );

  if (inline) {
    return (
      <div className={`flex items-center gap-3 ${className}`}>
        {content}
      </div>
    );
  }

  return (
    <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
      {content}
    </div>
  );
}

export function GlobalLoaderSkeleton({ className = "" }: { className?: string }) {
  return (
    <div className={`flex flex-col items-center justify-center gap-4 py-12 ${className}`}>
      <GlobalLoader size="md" />
      <div className="w-32 h-2 bg-background-200 rounded-full animate-pulse" />
      <div className="w-24 h-2 bg-background-200 rounded-full animate-pulse" />
    </div>
  );
}